import React, { Component } from 'react'

import OgaTable from "components/OgaTables/OgaTable";

import { connect } from "react-redux";

import moment from "moment";

import history from 'routes/History/history';

import {
    fetchAccountInfo,
    updateFilterTransactionType,
    updateFilterAccountTransType,
    updateFilterStartDate,
    updateFilterEndDate
} from "reducers/wallet/walletActions";

import { Well, Row, Col, FormGroup, Button } from "react-bootstrap";
import DatetimeRangePicker from 'react-datetime-range-picker';

import AccountTransTypeSelect from 'components/AccountTransTypeSelect/AccountTransTypeSelect';
import TransactionTypeSelect from 'components/TransactionTypeSelect/TransactionTypeSelect';
import NoInfo from 'components/NoInfo/NoInfo';

class Wallet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            quantityRows: 10
        };
    }

    componentWillMount() {
        this.loadAccountInfo(1, null, null, this.props.filterStartDate, this.props.filterEndDate);
    }

    loadAccountInfo(pageNumber, transactionType, accountTransType, startDate, endDate) {
        this.setState({ loading: true });
        let promise = new Promise((resolve, reject) => {
            let requestData = {
                quantityRows: this.state.quantityRows,
                pageNumber: pageNumber,
                transactionType: transactionType,
                accountTransactionType: accountTransType,
                startDate: startDate === "" ? null : startDate,
                endDate: endDate === "" ? null : endDate
            }

            this.props.fetchAccountInfo(requestData, resolve, reject);
        });
        promise.then(() => {
            this.setState({ loading: false });
        });
    }

    handleTransactionTypeChange(transactionType) {
        let value = transactionType != null ? transactionType.value : null;
        this.props.updateFilterTransactionType(value);
        this.loadAccountInfo(1, value, this.props.accountTransactionType, this.props.filterStartDate, this.props.filterEndDate);
    }

    handleAccountTransactionTypeChange(accountTransType) {
        let value = accountTransType != null ? accountTransType.value : null;
        this.props.updateFilterAccountTransType(value);
        this.loadAccountInfo(1, this.props.transactionType, value, this.props.filterStartDate, this.props.filterEndDate);
    }

    handleStartDateChange(date) {
        console.log("handleStartDateChange", date);
        let value = typeof date === 'string' ? "" : moment(date).format('DD/MM/YYYY');
        this.props.updateFilterStartDate(value);

        this.loadAccountInfo(1, this.props.transactionType, this.props.accountTransactionType, value, this.props.filterEndDate);
    }

    handleEndDateChange(date) {
        let value = typeof date === 'string' ? null : moment(date).format('DD/MM/YYYY');
        this.props.updateFilterEndDate(value);
        this.loadAccountInfo(1, this.props.transactionType, this.props.accountTransactionType, this.props.filterStartDate, value);
    }

    onPageChange = (pageNumber) => {
        this.loadAccountInfo(pageNumber + 1, this.props.transactionType, this.props.accountTransactionType, this.props.filterStartDate, this.props.filterEndDate);
    }

    goToWalletTransfer() {
        history.push("/wallet-transfer")
    }

    goToCreateDisbursement() {
        history.push("/create-disbursement")
    }

    goToCreateUnlockRequest(){
        history.push("/create-unlock-request");
    }

    render() {
        return (
            <div>

                {this.props.account != null &&
                <div>
                    <Row>
                        <Col md={4}>
                            <FormGroup >
                                <AccountTransTypeSelect
                                    selection={this.props.filterAccountTransType}
                                    handleChange={(type) => this.handleAccountTransactionTypeChange(type)}
                                />
                            </FormGroup >
                        </Col>
                        <Col md={4}>
                            <FormGroup >
                                <TransactionTypeSelect
                                    selection={this.props.filterTransactionType}
                                    handleChange={(type) => this.handleTransactionTypeChange(type)}
                                />
                            </FormGroup >
                        </Col>

                    </Row>

                    <FormGroup>
                        <DatetimeRangePicker
                            dateFormat={"DD/MM/YYYY"}
                            inputProps={{ className: "form-control form-control-sm", placeholder: "Seleccione rango de fechas" }}
                            onChange={this.handler}
                            timeFormat={false}
                            className="row"
                            pickerClassName="col-md-4 form-group"
                            onStartDateChange={(moment) => this.handleStartDateChange(moment)}
                            onEndDateChange={(moment) => this.handleEndDateChange(moment)}
                            startDate={this.props.filterStartDate}
                            endDate={this.props.filterEndDate}
                        />
                    </FormGroup>
                </div>
                }

                <div className="d-flex flex-row-reverse">
                    <FormGroup >
                        <Button className="bg-light-secondary"
                                onClick={() => this.goToCreateUnlockRequest()}>
                            Habilitar saldo pendiente
                        </Button>
                    </FormGroup>
                </div>

                <div className="d-flex flex-row-reverse">
                    <FormGroup >
                        <Button className="bg-light-secondary" disabled={this.props.account != null && !this.props.account.onTime}
                                onClick={() => this.goToCreateDisbursement()}>
                            Solicitar desembolso
                        </Button>
                    </FormGroup>
                </div>
                {this.props.account != null && this.props.account.allowed === 'true' &&
                <div className="d-flex flex-row-reverse">
                    <FormGroup>
                        <Button className="bg-light-secondary"
                                onClick={() => this.goToWalletTransfer()}>
                            Transferir a otra billetera
                        </Button>
                    </FormGroup>
                </div>
                }
                {this.props.account != null &&
                <div>
                    <div className="d-flex flex-row-reverse wallet-balance__container">
                        <Well bsSize="large" bsClass="card__info text-right">
                            <div>Saldo pendiente:  <b>{this.props.account.taxBlockedAmount} Bs</b></div>
                            { parseFloat(this.props.account.balanceToBill) > 0 &&
                            <div>Saldo a facturar:  <b>{this.props.account.balanceToBill} Bs</b></div>
                            }
                            <div>Saldo disponible:  <b>{this.props.account.availableBalance} Bs</b></div>
                            <div>Desembolso solicitado:  <b>{this.props.account.totalDisbursementRequested} Bs</b></div>
                            <div>Saldo total:  <b>{this.props.account.totalBalance} Bs</b></div>
                        </Well>
                    </div>
                    {this.props.account.transactions.length > 0 ?
                        <OgaTable
                            loading={this.state.loading}
                            headers={["Fecha", "Tipo de Transacción", "Descripción", "Ingreso(Bs)", "Egreso(Bs)", "Saldo(Bs)"]}
                            properties={["date", "type", "description", "in", "out", "partialBalance"]}
                            pullRight={[3, 4, 5]}
                            pageCount={this.props.account.count}
                            onPageChange={this.onPageChange}
                            values={this.props.account.transactions} />
                        :
                        <NoInfo text="No tiene transacciones registradas" />
                    }
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    account: state.account.data,
    accountTransactionType: state.account.accountTransactionType,
    transactionType: state.account.transactionType,
    filterStartDate: state.account.filterStartDate,
    filterEndDate: state.account.filterEndDate
});

export default connect(mapStateToProps,
    {
        fetchAccountInfo,
        updateFilterTransactionType,
        updateFilterAccountTransType,
        updateFilterStartDate,
        updateFilterEndDate
    })(Wallet);



// WEBPACK FOOTER //
// ./src/components/Wallet/Wallet.jsx